module.exports = __webpack_public_path__ + "img/bunny_chow.aea9f1a9.jpg";